import httpbaseURL from "../common/axios";
class Commonservices {
  Create(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/EntityMaster/Create",
      doc
    );
  }
  List() {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get("/EntityMaster/List");
  }
  ListEntityByModuleId(ModuleId) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityMaster/ListEntityByModuleId?ModuleId=" + ModuleId + ""
    );
  }
  Edit(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityMaster/Get?id=" + Id
    );
  }
  Update(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/EntityMaster/Update",
      doc
    );
  }
  Delete(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.delete(
      "/EntityMaster/Delete?ID=" + Id
    );
  }

  GetEntityByModuleId(moduleid) {
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityMaster/GetEntityByModuleId?ModuleId=" + moduleid + ""
    );
  }
  GetRightsByRoleId(RoleId, ModuleId) {
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/EntityOperationsDeptRoleMap/GetRightsByRoleIdModuleId?RoleId=" +
        RoleId +
        "&ModuleId=" +
        ModuleId +
        ""
    );
  }
}
export default new Commonservices();
